import {Button, Col, Modal, Row} from "antd";
import {useEffect, useState} from "react";
import {useDownloadPolicyDataMutation} from "../../../redux/api/negotiationsApiSlice";
import {DownloadedPolicyDataModel} from "../../../types/negotiations";
import dayjs from "dayjs";

export default function RenewsButton({negId, confirmRenewal, renewWithoutChanges}: { negId: string, confirmRenewal: (toRenew: boolean, toModify: boolean | null) => void, renewWithoutChanges: boolean }) {

    const [downloadData, {isLoading}] = useDownloadPolicyDataMutation()

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)
    const [policyData, setPolicyData] = useState<DownloadedPolicyDataModel | null>(null)

    const downloadPolicyData = () => {
        downloadData(negId).unwrap()
            .then(res => {
                setPolicyData(res)
                setIsModalOpen(true)
            })
    }

    const modalFooter = () => {
        return <Row justify={"end"}>
            <Button
                onClick={() => onConfirmRenewal(true, true)}
                type={"primary"}>
                Rinnovo con modifiche
            </Button>
            {renewWithoutChanges && <Button
                onClick={() => onConfirmRenewal(true, false)}>
                Rinnovo senza modifiche
            </Button>}
            <Button
                type={"primary"}
                onClick={() => onConfirmRenewal(false, null)}
                danger>
                Blocca rinnovo
            </Button>
        </Row>
    }

    const onConfirmRenewal = (toRenew: boolean, toModify: boolean | null) => {
        confirmRenewal(toRenew, toModify)
        setIsModalOpen(false)
    }

    return <>
        <Modal
            centered
            width={600}
            open={isModalOpen}
            title={"Effettua rinnovo"}
            onCancel={() => setIsModalOpen(false)}
            footer={modalFooter()}
        >
            <h3>Dati aggiornati della polizza:</h3>
            {policyData && <Row gutter={[0, 10]} style={{marginTop: 10}} justify={"space-between"}>
                <Col span={12}>
                    <strong>Contraente</strong>
                </Col>
                <Col span={12}>
                    {policyData?.contractor ?? "-"}
                </Col>
                <Col span={12}>
                    <strong>Broker</strong>
                </Col>
                <Col span={12}>
                    {policyData?.broker ?? "-"}
                </Col>
                <Col span={12}>
                    <strong>Data di effetto</strong>
                </Col>
                <Col span={12}>
                    {policyData?.policy_effective_date ? dayjs(policyData.policy_effective_date).format('DD-MM-YYYY') : "-"}
                </Col>
                <Col span={12}>
                    <strong>Data scadenza</strong>
                </Col>
                <Col span={12}>
                    {policyData.policy_expiring_date ? dayjs(policyData?.policy_expiring_date).format('DD-MM-YYYY') : "-"}
                </Col>
                <Col span={12}>
                    <strong>Premio di rinnovo</strong>
                </Col>
                <Col span={12}>
                    {policyData?.premium ? new Intl.NumberFormat('it-IT', {
                        style: 'currency',
                        currency: 'EUR'
                    }).format(parseFloat(policyData.premium.replace(',', '.'))) : "-"}
                </Col>
                <Col span={12}>
                    <strong>Provvigioni Broker</strong>
                </Col>
                <Col span={12}>
                    {policyData?.fee_total_perc ? policyData.fee_total_perc + " %" : "-"}
                </Col>
            </Row>}
            {!policyData && <Row justify={"center"} style={{marginTop: 10}}>Nessun dato presente.</Row>}
        </Modal>
        <Button
            type={"default"}
            loading={isLoading}
            onClick={() => downloadPolicyData()}
        >
            Effettua Rinnovo
        </Button>
    </>
}